import css from './more-gifs.css'
import { sanitize } from 'dompurify'

const sentenceCase = string =>
    string
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')

export default function({ tags }, giphyUrl, trackingQueryString) {
    const tag = tags && tags.length ? sentenceCase(tags[0]) : ''
    return `<div class="${css.container}">
            <a class="${css.link}" 
                href="${giphyUrl}${
        tag
            ? 'explore/' +
              sanitize(tag)
                  .toLowerCase()
                  .replace(' ', '-')
            : ''
    }?${trackingQueryString}"
                onclick="trackEvent('Click', 'More GIFs')">
                <span>See more ${sanitize(tag)} GIFs</span>
                <i class="${css.linkIcon}"></i>
            </a>
        </div>`
}
